import React from 'react'

function StatsBar({ data, onClick, status }) {

    return (
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%', gap: '15px' }}>
            {data?.map((stat, index) => (<div key={`${stat.status}-${index}`} onClick={() => onClick(stat.key)} style={{ display: 'flex', flexDirection: 'column', padding: '8px', borderRadius: '8px', backgroundColor: status === stat.key ? '#e0e6fa' : '#fff', minWidth: '100px', cursor: 'pointer' }}>
                <label style={{ fontSize: '16px', cursor: 'pointer' }}>{stat.label}</label>
                <label style={{ fontSize: '22px', color: '#2576bc', fontWeight: 500, cursor: 'pointer' }}>{stat.count}</label>
            </div>))}
        </div>
    )
}

export default StatsBar